module.exports = __webpack_public_path__ + "assets/skill-speaking.3e86f97f.svg";